// extracted by mini-css-extract-plugin
export default {"productsSwiper":"productsSlider_productsSwiper__829Uw","products":"productsSlider_products__6i4iO"};